import { logout } from "screens/Root/actions/appActions";
import { useDispatch } from "react-redux";
import { IconButton } from "../../components/IconButton";
const HeaderLogoutIcon = () => {
    const dispatch = useDispatch();
    const handleClick = () => dispatch(logout());
    return (<IconButton onClick={handleClick} tooltip="Log Out" identification="header-logout">
      logout
    </IconButton>);
};
export default HeaderLogoutIcon;
